import React from 'react';
import './index.scss';
import { reviewsFormat } from '@op/utils/value';
import { RankKeyMeticsItem } from '../../../component/TrendCardTips';
import { useGameOperations } from '@op/utils/game';
import RenderGameIcon from '@op/components/RenderImg/renderGameIcon';
import BubbleCommon, { TipsMapType } from '@op/components/BubbleCommon';
import { Bubble } from 'tea-component';  
import { JumpType } from '@home/utils/utils';

const rankList: { [key: number]: string; } = {
  1: '1st',
  2: '2nd',
  3: '3rd',
};

export default function RankCard({
  title,
  rankData,
  valueFormat = reviewsFormat,
  children,
  currentGame,
  showRank,
  tips,
  canNavigateToGame,
  jumpType,
  filter,
}: {
  title: string;
  children: any;
  rankData: { cover: string; value: number; }[];
  valueFormat?: (val: number) => number | string;
  currentGame: string;
  showRank: boolean;
  tips?: TipsMapType;
  canNavigateToGame?: boolean;
  jumpType?: JumpType;
  filter?: any;
}) {
  const currentRank =
    rankData?.findIndex((val) => val.game === currentGame) + 1;
  const { handleChangeGame } = useGameOperations({ jumpType, filter });
  return (
    <div className="dbo-rank-card">
      <BubbleCommon showIcon={false} tipsMap={tips} placement="top">
        <div className="dbo-rank-card-hd">
          <div className="dbo-rank-card-title">{title}</div>
        </div>
      </BubbleCommon>
      <div className="dbo-rank-card-bd">
        {children}
        {/* 新增前三排名列表 */}
        {showRank && (
          <div className="dbo-rank-box">
            {rankData?.slice(0, 3).map((item: any, index) => (
              <Bubble key={item.entity_name} content={item.entity_name}>
                <div
                  key={index}
                  className="dbo-rank-box-item"
                  onClick={() => {
                    if (currentRank !== index + 1 || canNavigateToGame) {
                      handleChangeGame(item, true);
                    }
                  }}
                >
                  <div className="dbo-rank-box-item-avatar">
                    <RenderGameIcon
                      className="game-icon"
                      gameInfo={item}
                    ></RenderGameIcon>
                  </div>
                  <div className="dbo-rank-box-item-info">
                    <div className="dbo-rank-box-item-title">
                      {rankList?.[index + 1]}
                    </div>
                    <div className="dbo-rank-box-item-desc">
                      {valueFormat?.(item.value) || '-'}
                    </div>
                  </div>
                  {/* <TrendCardTips
                  valueFormat={valueFormat}
                  rankList={rankData}
                  currentRank={currentRank}
                  title={title}
                  logId={'KMMS_CompetitorRanking'}
                ></TrendCardTips> */}
                </div>
              </Bubble>
            ))}
          </div>
        )}
        {/* 排名标识  复用studio组件*/}
        <div className="dbo-compare-operation">
          <RankKeyMeticsItem
            list={rankData}
            rank={currentRank}
            noShow={showRank}
            valueFormat={valueFormat}
            title={title}
            logId={'KMMS_CompetitorRanking'}
            canNavigateToGame={canNavigateToGame}
          ></RankKeyMeticsItem>
        </div>
      </div>
    </div>
  );
}
